
var article = `
#### Paso 1

* En inicio buscar la palabra **ejecutar** y abrir la aplicación **Ejecutar**.

* En el cuadro de diálogo escribir la palabra **msconfig** y presionar Enter.

* **Clic en la pestaña *Servicios***.

* Buscar el servicio: **Servicio Orquestador de actualizaciones**.

* **Desmarcar la casilla** y luego reiniciar.

#### Paso 2

* En inicio buscar la palabra *servicios* y abrir la aplicación **Servicios**.

* Buscar el servicio: **Servicio Orquestador de actualizaciones**.

* **Doble clic** > **Propiedades** > **Detener**

* Elegir el *Tipo de inicio* como *Deshabilitado*, aplicar los cambios.
`

export default article;